var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnknown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m27.718 6 6.782 8.474V36h-27V6h20.218zm-1.442 3H10.5v24h21V15.526L26.276 9zM21 27a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm0-15a6 6 0 0 1 1.5 11.811V24a1.5 1.5 0 0 1-3 0v-1.5A1.5 1.5 0 0 1 21 21a3 3 0 1 0-3-3 1.5 1.5 0 0 1-3 0 6 6 0 0 1 6-6z",
    fill: "#000",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknown);
export default __webpack_public_path__ + "static/media/unknown.4d3c783fb4c4e6d678e7ba757ac8d20b.svg";
export { ForwardRef as ReactComponent };